<template>
  <div
    class="relative"
    @touchstart="$emit('touchstart')"
    @mouseenter="$emit('mouseenter')"
    @touchEnd="$emit('touchend')"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="flex size-full items-center justify-center">
      <slot name="action" />
    </div>
    <FadeInFromBottomTransition appear>
      <div
        v-show="isOpen"
        ref="panel"
        :style="{ maxHeight }"
        class="panel-container border-secondary-600 absolute right-0 z-60 min-w-fit overflow-x-hidden overflow-y-scroll border bg-white sm:min-w-max"
      >
        <IconCloseS
          class="absolute right-0 size-8 cursor-pointer"
          @click="$emit('mouseleave')"
        />
        <slot name="content" />
      </div>
    </FadeInFromBottomTransition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ isOpen: boolean }>()

defineEmits(['touchstart', 'mouseenter', 'touchend', 'mouseleave'])

const { isOpen } = toRefs(props)
const panel = ref<HTMLDivElement | null>(null)
const topSpacing = ref(0)

const checkPosition = () => {
  topSpacing.value = panel.value?.getBoundingClientRect().top || 0
}

const maxHeight = computed(() => `calc(100vh - ${topSpacing.value}px)`)

useWatch(isOpen, (isOpenNow) => {
  if (isOpenNow) {
    nextTick(checkPosition)
  }
})
</script>
